<template>
  <v-card>
    <v-btn color="primary" class="ma-4" @click="imprimir()">
      <v-icon class="mr-2">mdi-printer</v-icon>Ticket
    </v-btn>
    <v-chip
      v-if="ticket.order.saldo_favor"
      color="blue"
      pill
    >Esta orden tiene un saldo a favor de: {{ticket.order.saldo_favor}}</v-chip>

    <div class="ticket" id="ticketVenta">
      <TicketVenta :venta="getInfoTicket"></TicketVenta>
    </div>
  </v-card>
</template>
<script>
import moment from "moment"
import TicketVenta from './TicketDeVenta.vue'
export default {
  name: "TicketOrden",
  data() {
    return {
      // sesion: JSON.parse(sessionStorage.getItem('sesion')),
    };
  },
  props: {
    ticket: {},
  },
  components: {
    TicketVenta
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  methods: {
    imprimir() {
      let imprimir = "";
      imprimir = document.getElementById("ticketVenta");
      var ventana = "";
     let tituloImpresion = this.ticket.order.order;

      ventana = window.open("", "PRINT", `height=400,width=600`);
      ventana.document.write("<html><head><title>" + tituloImpresion + "</title>");
      ventana.document.write('<link rel="stylesheet" href="/css/ticketVenta.css">');
      ventana.document.write("</head><body >");
      ventana.document.write(imprimir.innerHTML);
      ventana.document.write("</body></html>");
      ventana.document.close();
      ventana.focus();
      setTimeout(() => {
        ventana.print();
      }, 2000);
    },
    getName() {
      let nameAux = ""
      if(this.ticket.order._id) {
        nameAux = this.ticket.order.client.name +
              " " +
              this.ticket.order.client.first_lastname
      } else {
        nameAux = "PUBLICO EN GENERAL"
      }
      return nameAux;
    },
    getVehiculo(){
      let vehiculo = ""
      if(this.ticket.order._id && this.ticket.order.vehicle.license_plate){
        vehiculo = this.ticket.order.vehicle.license_plate
      }else {
        vehiculo = "N/A"
      }
      return vehiculo
    },
    getMarca() {
      let marca = ""
      if(this.ticket.order._id && this.ticket.order.vehicle.model.brand.name) {
        marca = this.ticket.order.vehicle.model.brand.name
      } else {
        marca = "N/A"
      }
      return marca
    },
  },
  computed: {
    fechaOrden() {
      return moment(this.ticket.order.createdAt).format("YYYY-MM-DD")
    },
    getInfoTicket() {
      let info = {
        sales_details: this.ticket.sales_details,
        cliente: this.getName(),
        vehiculo: this.getVehiculo(),
        marca: this.getMarca(),
        ticket: this.ticket,
        fecha: moment(new Date()).format("YYYY/MM/DD"),
        fechaOriginal: moment(this.ticket.order.createdAt).format("YYYY-MM-DD"),
        subTotal: (this.ticket.ventas_subtotales).toFixed(2),
        iva: (this.ticket.ventas_iva_tot).toFixed(2),
        total: (this.ticket.ventas_total).toFixed(2),
        formaPago: null,
        folio: this.ticket.order.order,
        reimpresion: true,
        nota: this.ticket.order.nota_final ? this.ticket.order.nota_final : false,
        cantidadArticulos: this.ticket.sales_details.length
      }
      return info
    }
  }
}
</script>
